import { render, staticRenderFns } from "./edit-information.vue?vue&type=template&id=afae94c2&scoped=true&"
import script from "./edit-information.vue?vue&type=script&lang=js&"
export * from "./edit-information.vue?vue&type=script&lang=js&"
import style0 from "./edit-information.vue?vue&type=style&index=0&id=afae94c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afae94c2",
  null
  
)

export default component.exports